import { Canvas } from '@react-three/fiber'
import { createFileRoute, useSearch } from '@tanstack/react-router'
import { Suspense } from 'react'
import AsciiColorGradient from '../components/three/scene'
import type { } from '../routeTree.gen'

export const Route = createFileRoute('/canvas/')({
  component: RouteComponent,
})

function RouteComponent() {
  const search = useSearch({ strict: false }) as { ascii?: string | number | boolean }
  const asciiParam = search?.ascii
  const asciiEnabled = asciiParam === undefined
    ? true
    : (asciiParam === true || asciiParam === 'true' || asciiParam === 1 || asciiParam === '1')

  return (
    <div className="fixed inset-0 -z-10">
      <Canvas dpr={[1, 1.5]} gl={{ antialias: true }}>
        <Suspense fallback={null}>
          <AsciiColorGradient asciiEnabled={asciiEnabled} />
        </Suspense>
      </Canvas>
    </div>
  )
}
